import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPlay(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53 3.152C8.22173 2.95933 7.83319 2.94913 7.51523 3.12536C7.19728 3.30158 7 3.63648 7 4V20C7 20.3635 7.19728 20.6984 7.51523 20.8746C7.83319 21.0509 8.22173 21.0407 8.53 20.848L19.53 12.848C19.8224 12.6653 20 12.3448 20 12C20 11.6552 19.8224 11.3347 19.53 11.152L8.53 3.152ZM9 18.1958V5.80425L17.1132 12L9 18.1958Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
